import "core-js/modules/es6.function.name";
//
//
//
//
//
import echarts from 'echarts';
import tdTheme from './theme.json';
import { off, on } from '@/libs/tools';
import { chartMixins } from './chartMixins';
echarts.registerTheme('tdTheme', tdTheme);
export default {
  name: 'ChartPie',
  mixins: [chartMixins],
  props: {
    value: Array,
    text: String,
    subtext: String,
    indicator: Array
  },
  data: function data() {
    return {
      dom: null,
      option: {}
    };
  },
  methods: {
    resize: function resize() {
      this.dom.resize();
    },
    init: function init() {
      this.dom = echarts.init(this.$refs.dom, 'tdTheme');
      this.dom.setOption(this.setParams(this.value));
      on(window, 'resize', this.resize);
    },
    setOption: function setOption(value) {
      this.dom.setOption(this.setParams(value));
    },
    setParams: function setParams(value) {
      var legend = value.map(function (_) {
        return _.name;
      });
      this.option = {
        title: {
          text: this.text,
          subtext: this.subtext,
          x: 'center',
          bottom: '0'
        },
        tooltip: {},
        legend: {
          left: 'center',
          top: '0',
          data: legend,
          textStyle: {
            color: '#fff'
          }
        },
        radar: {
          radius: '55%',
          center: ['50%', '55%'],
          name: {
            textStyle: {
              color: '#66cccc',
              borderRadius: 3,
              padding: [0, 0]
            }
          },
          splitArea: {
            areaStyle: {
              color: ['transparent', 'transparent', 'transparent', 'transparent'],
              backgroundColor: 'transparent'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#0A5F7D'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#0A5F7D'
            }
          },
          indicator: this.indicator
        },
        series: [{
          name: 'gg',
          type: 'radar',
          data: value
        }]
      };
      return this.option;
    }
  },
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    off(window, 'resize', this.resize);
  }
};